import React from 'react'
import { RefreshIcon } from '@heroicons/react/outline'
import Tooltip from '../../../csr/components/Tooltip/Tooltip'


const VerificationCode = ({
  code,
  handleRefreshCode,
  loading = false,
  IconComponent = RefreshIcon,
}) => {
  const handleClickRefresh = () => {
    if (!loading) {
      handleRefreshCode()
    }
  }

  const strCode = String(code)

  return (
    <div className="flex items-center justify-center">
      <div className="flex">
        {[...strCode].map((char, i) => (
          <div
            key={`code_${i}`}
            className="flex items-center justify-center bg-gray-400 rounded text-white h-12 p-2 w-9 mr-2"
          >
            {char}
          </div>
        ))}
      </div>

      {!loading && (
        <div onClick={handleClickRefresh} role="button" tabIndex="0" className="flex items-center">
          <IconComponent data-tooltip-id="reload-tooltip" data-tooltip-html="<div>Reload verification code <br />  (it may not change)</div>" className="text-gray-600 cursor-pointer h-6 w-6" />
          <Tooltip className="rounded-md font-normal bg-gray-800 max-w-sm text-center hidden lg:block" id="reload-tooltip" />
        </div>
      )}
      {loading && (
        <div className="flex items-center">
          <RefreshIcon className="text-gray-600 cursor-pointer h-6 w-6 animate-spin" />
        </div>
      )}
        <img data-tooltip-id="reload-tooltip2" data-tooltip-html="<div>Reload verification code <br />  (it may not change)</div>" src="/icons/tooltip.svg" alt="tooltip" className="inline-block ml-2 mb-1 opacity-70 lg:hidden" />
        <Tooltip className="rounded-md font-normal bg-gray-800 max-w-sm text-center" id="reload-tooltip2" />
    </div>
  )
}

export default VerificationCode
